module.exports = __webpack_public_path__ + "static/media/CheckMark_Large_Outline_white.dc380bea.svg";